module.exports = __webpack_public_path__ + "img/importDataLoading.a8337b57.gif";